import styled from "styled-components";
import { SmBannerImg } from "../../styled/AllImages";

export const SmBanner = styled.div`
    .smBannerInner{
        display: flex;
        height: 100%;
        min-height: 250px;
        align-items: center;
        background-image: url(${SmBannerImg});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
        cursor: pointer;
    }
    
    @media (max-width: 991px) {
        width: 100%;
    }
    @media (max-width: 767px) {
        /* border-radius: 0px; */
        /* box-shadow: none; */
        padding-left: 16px;
        padding-right: 16px;
        background-color: var(--white);
    }
    
`
export const InquiryStatsBannerWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    height: 100%;
    align-items: center;
    .InquiryStatsBannerContent{
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        position: relative;
        padding: 24px;
        & > *{
            width: 100%;
        }
        .stats-box{
            display: flex;
            align-items: center;
            gap: 15px;
        }
        .stat-icon{
            border-radius: 10px;
            padding: 15px;
            background-color: var(--bg);
        }
    }
    @media (max-width: 1299px) {
        .InquiryStatsBannerContent{
        }
        
    }
    @media (max-width: 1199px) {
        .InquiryStatsBannerContent{
        }
        
    }
    @media (max-width: 991px) {
        .InquiryStatsBannerContent{
        }
        
    }
    @media (max-width: 500px) {
        .InquiryStatsBannerContent{
            /* padding-right: 150px; */
        }
        
    }
    @media (max-width: 399px) {
        .InquiryStatsBannerContent{
            /* padding-right: 24px; */
        }
        
    }
`